import { POSMaterial, POSMaterialSaveObject } from './POSMaterial';
import { Utils } from '../../../core/services/utils.service';
import { POSTextHorizontalAlign, POSTextVerticalAlign } from './posTextAlign';

export interface POSMaterialTextSaveObject extends POSMaterialSaveObject {
	color: string;
	fontSize: number;
	backgroundColor: string;
	horizontalAlign: POSTextHorizontalAlign;
	verticalAlign: POSTextVerticalAlign;
}

export class POSTextMaterial extends POSMaterial {

	private _color: string;
	private _fontSize: number;
	private _backgroundColor: string;
	private _horizontalAlign: POSTextHorizontalAlign;
	private _verticalAlign: POSTextVerticalAlign;

	public set color(color: string) {
		this._color = color ?? '#000000';
	}

	public get color(): string {
		return this._color;
	}

	public set fontSize(fontSize: number) {
		this._fontSize = fontSize ?? 16;
	}

	public get fontSize(): number {
		return this._fontSize;
	}

	public set backgroundColor(backgroundColor: string) {
		this._backgroundColor = backgroundColor ?? '#ffffff00';
    	}

	public get backgroundColor(): string {
		return this._backgroundColor;
	}

	public set horizontalAlign(horizontalAlign: POSTextHorizontalAlign) {
		this._horizontalAlign = horizontalAlign ?? POSTextHorizontalAlign.Left;
	}

	public get horizontalAlign(): POSTextHorizontalAlign {
		return this._horizontalAlign;
	}

	public set verticalAlign(verticalAlign: POSTextVerticalAlign) {
		this._verticalAlign = verticalAlign ?? POSTextVerticalAlign.Top;
	}

	public get verticalAlign(): POSTextVerticalAlign {
		return this._verticalAlign;
	}

	constructor(params: Partial<POSMaterialTextSaveObject> = {}) {
		if (Utils.isNullOrUndefined(params.name)) params.name = 'Text';
		super(params);

		this.color = params.color;
		this.fontSize = params.fontSize;
		this.backgroundColor = params.backgroundColor;
		this.horizontalAlign = params.horizontalAlign;
		this.verticalAlign = params.verticalAlign;
	}

	public copy(): POSTextMaterial {
		return new POSTextMaterial(this.saveObject());
	}

	public saveObject(): POSMaterialTextSaveObject {
		return {
			...super.saveObject(),
			color: this.color,
			fontSize: this.fontSize,
			backgroundColor: this.backgroundColor,
			horizontalAlign: this.horizontalAlign,
			verticalAlign: this.verticalAlign
		}
	}
}
